import { XMLBaseParser } from '../../../utils/XMLBaseParser';
import { AuthChoice } from '../data/AuthChoice';
import {
	authChoiceErrorString,
	UnsupportedAuthChoiceProtocolError,
	RequestTokenChoicesParseError,
} from '../../AuthErrors';
import { Logger } from '../../Logger';
import { logConstants } from '../../../utils/Constants';
import { RequestTokenChoicesJson, AuthChoiceJson } from '../data/AuthTypes';

export class RequestTokenChoicesParser extends XMLBaseParser<AuthChoice[]> {
	processParsedXML(jsonObj: RequestTokenChoicesJson): AuthChoice[] {
		const authChoices: AuthChoice[] = [];
		try {
			const choice = jsonObj.requesttokenchoices.choices.choice;
			if (Array.isArray(choice)) {
				for (const choiceObj of choice) {
					authChoices.push(new AuthChoice(choiceObj.protocol, choiceObj.location));
				}
			} else {
				const authChoiceJson = jsonObj.requesttokenchoices.choices
					.choice as AuthChoiceJson;
				authChoices.push(
					new AuthChoice(authChoiceJson.protocol, authChoiceJson.location)
				);
			}
		} catch (e) {
			Logger.getInstance().write(
				logConstants.ERROR,
				authChoiceErrorString.DSAUTH_REQUEST_TOKEN_CHOICES_PARSE_ERROR
			);
			throw new RequestTokenChoicesParseError(e);
		}

		return authChoices;
	}

	getAuthChoice(xml: string, choice: string): AuthChoice {
		const jsonObj = super.parse(xml) as RequestTokenChoicesJson;
		const authChoices = this.processParsedXML(jsonObj);
		for (const authChoice of authChoices) {
			if (authChoice.validate(choice)) {
				return authChoice;
			}
		}

		Logger.getInstance().write(
			logConstants.ERROR,
			`${authChoiceErrorString.DSAUTH_CHOICE_PROTOCOL_NOT_SUPPORTED}: ${choice}`
		);
		throw new UnsupportedAuthChoiceProtocolError(
			`${authChoiceErrorString.DSAUTH_CHOICE_PROTOCOL_NOT_SUPPORTED}: ${choice}`
		);
	}
}
